<template>
    <div class="taker-details">
        <h6>{{nodeDetails.name}}</h6>
        <p>Status : <i :class="iconClass"></i> <strong :class="textClass">{{textValue}}</strong></p>
        <p>Active alerts: {{ nodeDetails.nb_active_alerts ? nodeDetails.nb_active_alerts : 0 }}</p>
        <p>Preview url: {{nodeDetails.preview_url ? nodeDetails.preview_url : 'No preview url given'}}</p>
        <p>Input status: {{nodeDetails.input_status}}</p>
        <p>Input bitrate: {{nodeDetails.channel_input_bitrate || nodeDetails.channel_input_bitrate === 0 ? parseInt(nodeDetails.channel_input_bitrate) : 'No bitrate given'}}</p>
        <p>Output bitrate: {{nodeDetails.channel_output_bitrate || nodeDetails.channel_output_bitrate === 0 ? parseInt(nodeDetails.channel_output_bitrate) : 'No bitrate given'}}</p>
    </div>
</template>

<script>

export default {

    components: {
    },

    props: {
        nodeDetails: {
            type: Object,
            required: true
        }

    },

    data: function(){
        return {
            iconClassByStatus: {
                'success': 'el-icon-success text-success',
                'unstable': 'el-icon-warning text-warning',
                'failure': 'el-icon-error text-danger',
            },
            textClassByStatus: {
                'success': 'text-success',
                'unstable': 'text-warning',
                'failure': 'text-danger',
            },
            textValueByStatus: {
                'success': 'OK',
                'unstable': 'WARNING',
                'failure': 'ERROR',
            }
        };
    },

    computed: {
        iconClass() {
            return this.iconClassByStatus[this.nodeDetails.status];
        },
        textClass() {
            return this.textClassByStatus[this.nodeDetails.status];
        },
        textValue() {
            return this.textValueByStatus[this.nodeDetails.status];
        }
    },

    mounted: function(){

    },

    methods: {
    },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/page/Monitoring/previewDetails.vue